/* eslint-disable */
import React, { useContext } from 'react';
import {
  makeStyles,
  Popover,
} from '@material-ui/core';
import { checkPermission } from 'helpers/checkPermissions';
import { useSelector } from 'react-redux';
import { AppRouteContext } from 'contexts';
import {
  Dashboard as DashboardIcon,
  Folder as ResourcesIcon,
  People as PeopleIcon, Settings as AdminIcon,
} from '@material-ui/icons';
import { ALL_ROUTES } from '../../../../../../../config/routes';

const useStyles = makeStyles((theme) => ({
  popover: {
    pointerEvents: 'none',
    zIndex: 20000,
    '& .MuiPopover-paper': {
      overflow: 'visible',
      filter: 'drop-shadow(0px 8px 32px rgba(0, 0, 0, 0.12))',
      zIndex: 20001,
    },
  },
  popoverContent: {
    pointerEvents: 'auto',
    background: 'rgba(255, 255, 255, 0.95)',
    backdropFilter: 'blur(20px)',
    WebkitBackdropFilter: 'blur(20px)',
    border: '1px solid rgba(229, 231, 235, 0.6)',
    borderRadius: 12,
    minWidth: 220,
    maxWidth: 280,
    overflow: 'hidden',
    position: 'relative',
    marginLeft: 4,
    zIndex: 1002,
  },
  popoverHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1.25, 1.5),
    borderBottom: '1px solid rgba(229, 231, 235, 0.4)',
    background: 'rgba(249, 250, 251, 0.6)',
  },
  popoverHeaderIcon: {
    color: 'rgba(55, 65, 81, 0.8)',
    marginRight: theme.spacing(1),
    fontSize: 16,
  },
  popoverHeaderTitle: {
    color: 'rgba(17, 24, 39, 0.9)',
    fontSize: '0.75rem',
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  },
  popoverList: {
    padding: theme.spacing(0.5, 0),
  },
  popoverItem: {
    padding: theme.spacing(0.875, 1.5),
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    transition: 'all 0.15s cubic-bezier(0.4, 0.0, 0.2, 1)',
    position: 'relative',
    margin: theme.spacing(0, 0.5),
    borderRadius: 6,

    '&:hover': {
      backgroundColor: 'rgba(59, 130, 246, 0.08)',
      transform: 'translateX(2px)',

      '& $popoverItemText': {
        color: 'rgba(17, 24, 39, 0.9)',
      },
    },

    '&:active': {
      transform: 'translateX(1px) scale(0.98)',
    },
  },
  popoverItemIcon: {
    marginRight: theme.spacing(1.25),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 20,
    transition: 'color 0.15s ease',
    '& svg': {
      width: 16,
      height: 16,
      stroke: 'none !important',
      strokeWidth: '0 !important',
    },
  },
  popoverItemText: {
    color: 'rgba(55, 65, 81, 0.85)',
    fontSize: '0.825rem',
    fontWeight: 500,
    lineHeight: 1.4,
    transition: 'color 0.15s ease',
  },
  popoverItemSelected: {
    backgroundColor: 'rgba(59, 130, 246, 0.1)',
    border: '1px solid rgba(59, 130, 246, 0.25)',

    '& $popoverItemText': {
      color: 'rgba(37, 99, 235, 0.95)',
      fontWeight: 600,
    },

    '&:hover': {
      backgroundColor: 'rgba(59, 130, 246, 0.15)',
      transform: 'translateX(2px)',

      '& $popoverItemText': {
        color: 'rgba(37, 99, 235, 1)',
      },
    },
  },
  popoverItemChild: {
    paddingLeft: theme.spacing(6.5),
    position: 'relative',

    '&::before': {
      content: '""',
      position: 'absolute',
      left: theme.spacing(4.2),
      top: '50%',
      transform: 'translateY(-50%)',
      width: 4,
      height: 4,
      borderRadius: '50%',
      backgroundColor: 'rgba(107, 114, 128, 0.6)',
    },
  },
  popoverItemChildSelected: {
    '&::before': {
      backgroundColor: 'rgba(37, 99, 235, 0.8)',
    },
  },
}));


const CollapsedMenu = ({
                         hoverTimeout,
                         setHoverTimeout,
                         popoverState,
                         setPopoverState,
                         handlePopoverCancelClose,
                         handlePopoverDelayedClose,
                       }) => {
  const NAV_GROUPS = [
    {
      id: 'core',
      title: 'Dashboard',
      icon: DashboardIcon,
      items: [
        { route: ALL_ROUTES.dashboard.root, icon: ALL_ROUTES.dashboard.root.additional.icon },
        { route: ALL_ROUTES.alert.list, icon: ALL_ROUTES.alert.list.additional.icon },
        { route: ALL_ROUTES.account.listDS, icon: ALL_ROUTES.account.listDS.additional.icon },
      ]
    },
    {
      id: 'patients',
      title: 'Patient Care',
      icon: PeopleIcon,
      items: [
        { route: ALL_ROUTES.patient.list, icon: ALL_ROUTES.patient.list.additional.icon },
        { route: ALL_ROUTES.order.list, icon: ALL_ROUTES.order.list.additional.icon },
        { route: ALL_ROUTES.assessment.list, icon: ALL_ROUTES.assessment.list.additional.icon },
        { route: ALL_ROUTES.program.list, icon: ALL_ROUTES.program.list.additional.icon },
      ]
    },
    {
      id: 'resources',
      title: 'Resources',
      icon: ResourcesIcon,
      items: [
        { route: ALL_ROUTES.allergiEndResources.dashboard, icon: ALL_ROUTES.allergiEndResources.dashboard.additional.icon },
        { route: ALL_ROUTES.resource.list, icon: ALL_ROUTES.resource.list.additional.icon },
      ]
    }
  ];

  const NAV_ADMIN_GROUP = {
    id: 'admin',
    title: 'Administration',
    icon: AdminIcon,
    items: [
      { route: ALL_ROUTES.claim.list, icon: ALL_ROUTES.claim.list.additional.icon },
      { route: ALL_ROUTES.reportable.list, icon: ALL_ROUTES.reportable.list.additional.icon, isChild: true },
      { route: ALL_ROUTES.claimReport.list, icon: ALL_ROUTES.claimReport.list.additional.icon, isChild: true },
      { route: ALL_ROUTES.botActivity.list, icon: ALL_ROUTES.botActivity.list.additional.icon },
    ]
  };
  const classes = useStyles();
  const {
    metadata: { currentAccountPermissions, currentAccount },
  } = useSelector((state) => state.user);
  const { disabledFeatures} = useSelector((state) => state.appSettings);
  const { setAppRoute, breadcrumbs } = useContext(AppRouteContext);

  const handlePopoverImmediateClose = () => {
    // Close immediately
    setPopoverState({
      anchorEl: null,
      groupId: null,
    });
    if (hoverTimeout) {
      clearTimeout(hoverTimeout);
      setHoverTimeout(null);
    }
  };

  const handleNavItemClick = (item) => {
    const openInNewTab = (url) => {
      const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
      if (newWindow) newWindow.opener = null;
    };

    if (item.route.externalReference) {
      openInNewTab(item.route.path);
    } else {
      setAppRoute({
        path: item.route.path,
        title: item.route.additional.title,
        clearBreadcrumbs: true,
        params: {
          currentAccountUuid: currentAccount?.uuid,
        },
      });
    }

    // Close popover after navigation
    handlePopoverImmediateClose();
  };

  const getVisibleItems = (items) => {
    return items.filter(item => {
      if (!item.route?.additional?.permission) return true;
      return checkPermission(
        currentAccountPermissions,
        item.route.additional.permission,
      ) && !disabledFeatures.includes(item.route.additional.disabledId);
    });
  };

  // Get current popover group
  const popoverGroup = popoverState.groupId ?
    [...NAV_GROUPS, NAV_ADMIN_GROUP].find(g => g.id === popoverState.groupId) :
    null;
  const popoverItems = popoverGroup ? getVisibleItems(popoverGroup.items) : [];

  return (
    <Popover
      className={classes.popover}
      open={Boolean(popoverState.anchorEl)}
      anchorEl={popoverState.anchorEl}
      onClose={() => {
      }} // Disable automatic close
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      marginThreshold={0}
      getContentAnchorEl={null}
      PaperProps={{
        className: classes.popoverContent,
        'data-popover-content': 'true',
        onMouseEnter: handlePopoverCancelClose,
        onMouseLeave: handlePopoverDelayedClose,
      }}
    >
      {popoverGroup && (
        <>
          <div className={classes.popoverHeader}>
            <popoverGroup.icon className={classes.popoverHeaderIcon} />
            <span className={classes.popoverHeaderTitle}>
                {popoverGroup.title}
              </span>
          </div>
          <div className={classes.popoverList}>
            {popoverItems.map((item, index) => {
              const ItemIcon = item.icon;
              const isSelected = breadcrumbs[0]?.title
                && (breadcrumbs[0]?.title === item.route?.additional?.title
                  || breadcrumbs[0]?.title === item.route?.additional?.name);

              const isChild = item.isChild;

              return (
                <div
                  key={`popover-${popoverGroup.id}-${index}`}
                  className={`${classes.popoverItem} ${isSelected ? classes.popoverItemSelected : ''} ${isChild ? classes.popoverItemChild : ''} ${isChild && isSelected ? classes.popoverItemChildSelected : ''}`}
                  onClick={() => handleNavItemClick(item)}
                >
                  {!isChild && (
                    <div className={classes.popoverItemIcon}>
                      <ItemIcon
                        fill={isSelected ? 'rgba(37, 99, 235, 1)' : 'rgba(107, 114, 128, 0.8)'}
                      />
                    </div>
                  )}
                  <span className={classes.popoverItemText}>
                      {item.route?.additional?.title || item.route?.additional?.name}
                    </span>
                </div>
              );
            })}
          </div>
        </>
      )}
    </Popover>
  );
};

export default CollapsedMenu;
